import * as React from 'react';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import MessagebarContext from '../../../../context/MessagebarContext';
import AppointmentList from '../../calendar/components/AppointmentList';

const CalendarWidget = () => {
  const { setAlertMessage } = useContext(MessagebarContext);

  const { refetch, data: appointmentsList = [] } = useQuery(
    'appointments',
    async () => {
      try {
        const { data } = await axios('/appointment');
        const appointmentsList = Object.values(data);

        return appointmentsList;
      } catch (error) {
        setAlertMessage();
      }
    }
  );

  return <AppointmentList onRefresh={refetch} list={appointmentsList} hide />;
};

export default CalendarWidget;
